<div class="product-container d-flex justify-content-between align-items-center">
  <div class="d-flex align-items-center spacing-8">
    <img
      alt="product image"
      height="32"
      width="32"
      class="product-img"
      [ngSrc]="product.productImage || '/assets/No-Image-Placeholder.svg'" />
    <div class="d-flex flex-column justify-content-center align-items-start spacing-4">
      <h3 class="h3-bold m-0 p-0 primary-100" [class.red]="!product.available">
        {{ product.productName }}
      </h3>
      <div class="d-flex align-items-center spacing-8">
        <span role="text" class="h4-reg primary-60" [class.red]="!product.available">
          {{ currencySymbol }} {{ product.productPrice }}
        </span>
        <span class="dot-divder"></span>
        <span role="text" class="h4-reg primary-60" [class.red]="!product.available">
          {{ product.value }}
        </span>
        <span class="dot-divder"></span>
        <span class="h4-reg primary-60" [class.red]="!product.available">{{ product.stock }}</span>
      </div>
    </div>
  </div>
  <div class="d-flex align-items-center spacing-16" *ngIf="showBadge">
    <app-badges
      [Type]="product.badges.Type"
      [withIcon]="product.badges.withIcon"
      [IconType]="product.badges.IconType"
      [label]="product.badges.label"></app-badges>
    @if (editAction) {
      <app-action-btn
        [active]="false"
        (custom_click)="custon_click.emit({ action: 'edit', product: product })"
        IconType="edit"></app-action-btn>
    }
    @if (deleteAction) {
      <app-action-btn
        [active]="false"
        (custom_click)="custon_click.emit({ action: 'delete', product: product })"
        IconType="trash"></app-action-btn>
    }
  </div>
</div>
